import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "App-Admin-Table",
      size: "medium",
      stripe: "",
      data: _ctx.businesses,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "el-icon-office-building" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.name)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "stage",
          label: "Stage",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.stage)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "businessModel",
          label: "Model",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.capitalize(scope.row.businessModel)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "industry",
          label: "Industry",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.industry)) + " Industry ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "coFoundersSize",
          label: "Founders",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.coFoundersSize + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "teamSize",
          label: "Team",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.teamSize), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "funding",
          label: "Funding",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (
              typeof scope.row.funding === 'object' &&
              scope.row.funding !== null
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(scope.row.funding.currency) + " " + _toDisplayString(_ctx.$filters.number(scope.row.funding.amount)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.funding), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Is Active",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              "model-value": !scope.row.isArchived,
              size: "mini"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Reset Score",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, { content: "Resets the survey score of this user." }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-refresh",
                  "is-borderless": "",
                  plain: "",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.resetScore(scope.row._id))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Reset ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}